(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  window.onload = function() {
    const color_swatch = document.querySelectorAll('.color-swatch');
    const app_color_swatch = document.querySelectorAll('.globo-product-groups-detail');
    const various_swatch = document.querySelectorAll('.various-swatch');

    if(various_swatch.length > 0 && app_color_swatch.length > 0){
      // alert(app_color_swatch.length);
      app_color_swatch[0].style.marginTop = '16px';
    }
  
    if(color_swatch.length > 0 && app_color_swatch.length > 0){
      color_swatch[0].style.display = 'none';
    }else if(color_swatch.length > 0 && app_color_swatch.length == 0){
      color_swatch[0].style.display = 'block';
    }
  };

  } catch(e) { console.error(e); }
})();
})();
